import React, { useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import api, { apiUrl } from "../../../services/api"
import axios from 'axios';

import "../transferir/Style.css";
import IntlCurrencyInput from "react-intl-currency-input"
import InputMask from "react-input-mask";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";

export default function () {

  const [valor, setValor] = useState('');
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [digito, setDigito] = useState('');
  const [cpf, setCpf] = useState('');
  const [nome, setNome] = useState('');
  const [banco, setBanco] = useState('')
  const [descritpion, setDescription] = useState('')
  const [response, setResponse] = useState({})

  const [receipt, setReceipt] = useState(false)
  const [loader, setLoader] = useState(false)

  const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const handleChange = (event, value, maskedValue) => {
    event.preventDefault();

    setValor(value); // value without mask (ex: 1234.56)
    console.log(maskedValue); // masked value (ex: R$1234,56)
  };

  const navigate = useNavigate();

  async function sendTransfers() {
    setLoader(true)
    if (valor == '' || agencia == '' || conta == '' || cpf == '' || nome == '' || banco == '' || digito == '') {
      toast.error('Preencha todos os campos !')
      setLoader(false)
      return;
    }

    const date = new Date(Date.now())

    const body = {
      'fromTaxNumber': localStorage.getItem('taxNumber'),

      'toName': nome,
      'toTaxNumber': cpf,
      'toBank': banco,
      'toBankBranch': agencia,
      'toBankAccount': conta,
      'toBankAccountDigit': digito,

      'value': valor,
      'rateValue': '0',

      'transferDate': date.toISOString(),
      'description': descritpion
    }

    console.log(body)

    const obj = {
      username: localStorage.getItem('taxNumber'),
      password: localStorage.getItem('identifier'),
      mac: localStorage.getItem('deviceId'),
      login: localStorage.getItem('login')
    }

    await api.post('/login/token', obj)
      .then(async function (result) {
        localStorage.setItem('token', result.data.token)

        const api2 = await axios.create({
          headers: {
              'Authorization': result.data.token,
              'device': localStorage.getItem('deviceId')
          },
          baseURL: apiUrl
        })

        var data = await api2.post('/transfer/store', body)
          .catch(err => {
            setLoader(false)
            toast.error(err.response.data.message)
            return
          })

        data = data.data.data
        console.log(response)
        toast.success('Transferência enviada!')
        setResponse(data)
        setLoader(false)
      })
  }


  return (
    <div>
      <div className="transferencia-ted">
        <div className="container">
          <div className="botao row">

            <div className="col-xl-8">
              <p>TED</p>
            </div>

            {/*<div className="col-xl-3">
              <Link to={"/pagina-tranferencia"}>
                <button style={{ backgroundColor: 'var(--secondary-color)' }}>Nova Transferência</button>
              </Link>
            </div>*/}

          </div>

          <div className="transferencia">
            <div className="row">
              <div className="col-xl-6 scroll">
                <div>
                  <h1>Nova transferência</h1>
                </div>

                <div>
                  <h2>Qual valor você deseja transferir?</h2>
                </div>

                <div>
                  <p>Valor</p>
                  <IntlCurrencyInput currency="BRL" config={currencyConfig}
                    onChange={handleChange}
                    placeholder="Digite o valor a ser transferido"
                    value={valor}
                  // onChange={e => { setValor(e.target.value) }}
                  />
                </div>

                <div>
                  <h2>Preencha os dados de quem irá receber a tranferência</h2>
                </div>

                <div>
                  <p>Banco</p>
                  <input
                    type="text"
                    placeholder="Digite o código do banco de destino"
                    value={banco}
                    onChange={e => { setBanco(e.target.value) }}
                  />
                  {/* <div className="seleciona">
                    <select name="select" value={banco} onChange={e => { setBanco(e.target.value) }}>
                      <option value="valor1">Selecione um tipo</option>
                      <option value="valor2" />
                      <option value="valor3" />
                    </select>
                  </div> */}
                </div>

                {/* <div>
                  <p>Tipo de Conta</p>
                  <div className="seleciona" >
                    <select name="select" value={TipoConta} onChange={e => { setTipoConta(e.target.value) }}>
                      <option value="valor1">Selecione um tipo</option>
                      <option value="valor2">Conta-Corrente</option>
                      <option value="valor3">Conta-Poupança</option>
                      <option value="valor4">Conta-Salário</option>
                    </select>
                  </div>
                </div> */}

                <div>
                  <p>Agência</p>
                  <InputMask
                    mask="9999"
                    placeholder="Digite agência de destino"
                    value={agencia}
                    onChange={e => { setAgencia(e.target.value) }} />

                </div>

                <div className="numero-conta">
                  <div className="row">
                    <div className="conta col-xl-6">
                      <p>Conta</p>
                      <InputMask
                        mask="999999999"
                        placeholder="Digite a conta de destino"
                        value={conta}
                        onChange={e => { setConta(e.target.value) }} />
                    </div>

                    <div className="conta col-xl-6">
                      <p>Dígito</p>
                      <InputMask
                        mask="9"
                        placeholder="Digite o dígito da conta"
                        value={digito}
                        onChange={e => { setDigito(e.target.value) }} />
                    </div>
                  </div>
                </div>

                <div>
                  <p>CPF ou CNPJ de quem vai receber</p>
                  <input
                    type="text"
                    placeholder="Digite o CPF ou CNPJ do destinatário"
                    value={cpf}
                    onChange={e => { setCpf(e.target.value) }} />
                </div>

                <div>
                  <p>Nome de quem irá receber</p>
                  <input type="text"
                    placeholder="Digite o nome completo"
                    value={nome}
                    onChange={e => { setNome(e.target.value) }} />
                </div>

                <div className="description">
                  <p style={{ 'marginBottom': '5px' }}>Descrição</p>
                  <textarea type="text"
                    placeholder="Digite a descrição do pagamento"
                    value={descritpion}
                    onChange={e => { setDescription(e.target.value) }} />
                </div>

                {/*     <div className="contato">
                  <div className="row">
                    <div className="contato1 col-xl-2">
                      <div className="iniciais">
                        <p>ED</p>
                      </div>

                      <div className="nome"
                      >
                        <p>Eduardo</p>
                      </div>
                    </div>

                    <div className="contato1 col-xl-2">
                      <div className="iniciais">
                        <p>FP</p>
                      </div>

                      <div className="nome">
                        <p>Felipe</p>
                      </div>
                    </div>

                    <div className="contato1 col-xl-2">
                      <div className="iniciais">
                        <p>JD</p>
                      </div>

                      <div className="nome">
                        <p>Jodie</p>
                      </div>
                    </div>
                  </div>
                </div> */}

              </div>

              <div className="col-xl-6">
                <div className="resumo-transferencia">
                  <div>
                    <h1>Resumo da transferência</h1>
                  </div>
                  <div style={receipt ? { 'display': 'block' } : { 'display': 'none' }}>
                    <div>
                      <h2>{response.toName}</h2>
                    </div>

                    <div>
                      <p>CPJ/CNPJ</p>
                      <h4>{response.toTaxNumber}</h4>
                    </div>

                    <div>
                      <p>Data</p>
                      <h4>{new Date(response.transferDate).toLocaleDateString()}</h4>
                    </div>

                    <div>
                      <p>Tipo de transferencia</p>
                      <h4>TED</h4>
                    </div>

                    <div>
                      <p>Banco</p>
                      <h4>{response.toBank}</h4>
                    </div>

                    <div className="agencia">
                      <div className="row">
                        <div className="col-xl-6">
                          <p>Agência</p>
                          <h4>{response.toBankBranch}</h4>
                        </div>

                        <div className="col-xl-6">
                          <p>Conta</p>
                          <h4>{response.toBankAccount + '-' + response.toBankAccountDigit}</h4>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3>Valor que será tranferido</h3>
                    </div>

                    <div>
                      <p>Valor</p>
                      <h4>R$ {response.value}</h4>
                    </div>

                    <div>
                      <h3>Código de autenticação</h3>
                      <h4>dsf213332-23243243d-324234234-42342344-432423434324334</h4>
                    </div>
                  </div>

                  <div style={loader ? { 'display': 'block', 'margin': 'auto', 'marginTop': '20px' } : { 'display': 'none' }}>
                    <BeatLoader color={"var(--secondary-color)"} loading={loader} css={override} size={20} />
                  </div>
                </div>

                <div className="botao-confirmar">
                  <button
                    style={loader ? { 'display': 'none' } : { 'display': 'block' }}
                    onClick={() => sendTransfers()}>Confirmar transferência
                  </button>

                  <button
                    style={loader ? { 'display': 'block' } : { 'display': 'none' }}
                    onClick={() => toast.info('Requisição em processamento!')} >
                    <BeatLoader color={"#fff"} loading={loader} css={override} size={10} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
